import { QuoteRecoverySourceEnum } from '@jove-frontend/enums';
import { GlobalState } from 'little-state-machine';

export interface ProductsFields {
  label: string;
  value: number;
  monthlyPrice?: string;
  isRequired?: boolean;
  label_price?: string;
}

export function updateAction(state: GlobalState, payload: GlobalState): GlobalState {
  return {
    ...state,
    ...payload,
  };
}

export function clearAction(state: GlobalState, payload: GlobalState) {
  return {
    contact: {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      country: '',
      organization_id: '',
    },
    business: {
      type: undefined,
      businessActivity: '',
      rentToRentBusinessActivity: '',
      activities: [''],
      turnover: '',
      name: '',
      number: '',
      address: '',
      address2: '',
      postcode: '',
      employees: 0,
      UKOnlyCustomers: false,
      turnoverBreakdownEU: 0,
      turnoverBreakdownOther: 0,
      turnoverBreakdownUK: 0,
      turnoverBreakdownUSA: 0,
      employeesSplit: {
        clerical: 0,
        manual: 0,
      },
      country: '',
    },
    ern: '',
    quote: {
      id: '',
      created_at: '',
      updated_at: '',
      viewed_at: '',
      notified: false,
    },
    projectPeriodStart: '',
    projectPeriodEnd: '',
    company: {
      name: '',
      registration_num: '',
      tax_num: '',
      company_incorporation_date: undefined,
    },
    elSize: {
      manualEmployees: 0,
      clericalEmployees: 0,
    },
    billingCycle: 'annual',
    policyNumber: '',
    currency: {
      code: 'GBP',
      symbol: '£',
    },
    personalData: {
      birthDate: undefined,
    },
    quoteRecoverySource: QuoteRecoverySourceEnum.Normal,
    greateAmerican: {},
    declarationQuestions: {},
    channel: '',
    quoteId: '',
    temporaryFieldMap: {
      isFromValidationAssumptionCreate: false,
      haveSavePageMap: {},
      isRestoreQuote: false,
    },
    hiscox: {},
  };
}
